var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreatePo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_53",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4105",
    "data-name": "Rectangle 4105",
    width: 32.381,
    height: 32.29,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9293",
    "data-name": "Group 9293",
    transform: "translate(8.823 6.054)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.82, -6.05)",
    filter: "url(#Ellipse_53)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53-2",
    "data-name": "Ellipse 53",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11212",
    "data-name": "Group 11212",
    transform: "translate(27.486 27.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11199",
    "data-name": "Group 11199",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M14.584,107.644v3.231H1.866a2.041,2.041,0,0,1-1.09-.266A1.6,1.6,0,0,1,.586,108a2,2,0,0,1,1.139-.356c.084-.008.169,0,.254,0Z",
    transform: "translate(0 -93.114)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M145.331,110.743a2.7,2.7,0,0,1-.814.142q-6.2.012-12.4.005h-.339V107.66h.348q6.2,0,12.4,0a2.854,2.854,0,0,1,.65.074,1.555,1.555,0,0,1,1.193,1.406,1.585,1.585,0,0,1-1.039,1.6",
    transform: "translate(-113.996 -93.13)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M111.261,14.181v16.26a2.268,2.268,0,0,1-.162.888,1.558,1.558,0,0,1-2.989-.443c-.03-.3-.047-.6-.047-.906q-.006-5.575,0-11.148V14.021q0-6.114,0-12.227a1.727,1.727,0,0,1,.575-1.4A1.488,1.488,0,0,1,110.2.107a1.5,1.5,0,0,1,1.014,1.275,6.627,6.627,0,0,1,.049.881q.006,5.958,0,11.917",
    transform: "translate(-93.476 0)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePo);
export default __webpack_public_path__ + "static/media/create-po.81b29a784373d4d54ba2eb419eff6efe.svg";
export { ForwardRef as ReactComponent };